import {
  faBan,
  faCalendarDays,
  faEnvelopeOpenText,
} from '@fortawesome/pro-duotone-svg-icons'

import { ChoiceTileOption } from '../../components/choice-tile/types'
import { QuickPassDigestFrequency } from '../../_types/quickpass-profile'

const profileContainerMotion = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.05, delayChildren: 0.05 },
  },
}

const profileItemMotion = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
}

const DIGEST_FREQUENCY_OPTIONS: ChoiceTileOption<QuickPassDigestFrequency>[] = [
  {
    value: 'never',
    title: 'Never',
    description: 'No digest emails — alerts only via the app.',
    icon: faBan,
  },
  {
    value: 'daily',
    title: 'Daily',
    description: 'One round-up email each morning, when there&rsquo;s news.',
    icon: faEnvelopeOpenText,
  },
  {
    value: 'weekly',
    title: 'Weekly',
    description: 'One curated email per week. Lower noise.',
    icon: faCalendarDays,
  },
]

export { profileContainerMotion, profileItemMotion, DIGEST_FREQUENCY_OPTIONS }
